import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { Marca } from '../models/marca';
import { ParametrosKit } from '../models/parametros-kit';
import { GlobalService } from './global.service';

@Injectable({
  providedIn: 'root'
})
export class ParametrosKitService {

  constructor(private globalService: GlobalService, private http: HttpClient) {

  }

  consultarParametrosKit(tipo, id, qtd, ativo) {
    return this.http.get<ParametrosKit[]>(globals.apiUrl + '/api/ParametrosKit/Lista',
      {
        params: new HttpParams().set('tipo', tipo)
          .set('id', id !== undefined && id !== null ? id : '')
          .set('qtd', qtd !== undefined && qtd !== null ? qtd : '')
          .set('ativo', ativo !== undefined && ativo !== null ? ativo : '')
      });
  }

  consultarPorIdKit(idKit) {
    return this.http.get<any>(globals.apiUrl + '/api/ParametrosKit/Buscar',
      { params: new HttpParams().set('id', idKit) });
  }

  salvar(parametro: ParametrosKit) {
    return this.http.post(globals.apiUrl + '/api/ParametrosKit/Salvar', parametro,
      { responseType: 'text' });
  }

  excluir(id) {
    return this.http.delete(globals.apiUrl + '/api/ParametrosKit/Excluir',
      { params: new HttpParams().set('id', id) });
  }

  gerarCombinacoes() {
    return this.http.get<any>(globals.apiUrl + '/api/ParametrosKit/GerarCombinacoes ');
  }

  consultarQtdCadastrado(idInversor, tipoParametro) {
    return this.http.get<number>(globals.apiUrl + '/api/ParametrosKit/QtdCadastrado',
      {
        params: new HttpParams().set('idInversor', idInversor).set('tipoParametro', tipoParametro)
      });
  }

}
